import { useAuthentication } from '@autone/auth';
import { useGetUserConfigQuery } from '@autone/redux/core';
import { usePostHog } from 'posthog-js/react';
import { Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PostHogPageView = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const searchParams = new URLSearchParams(location.search);
  const posthog = usePostHog();

  const {
    user: { userId },
  } = useAuthentication();
  const { data } = useGetUserConfigQuery(
    {},
    {
      // Skip item if no user id
      // otherwise the call to get user id on the auth
      // page will keep redirecting to the login route
      // in an infinite loop
      skip: !userId,
    },
  );

  const { customer_name } = data || {};
  const { email, company_title, forename, surname, username } =
    data?.profile || {};

  // Track pageviews
  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname;
      if (searchParams.toString()) {
        url = `${url}?${searchParams.toString()}`;
      }

      posthog.capture('$pageview', { $current_url: url });
    }
  }, [pathname, searchParams, posthog]);

  useEffect(() => {
    // 👉 Check the sign-in status and user info,
    //    and identify the user if they aren't already
    if (userId && email && !posthog._isIdentified()) {
      // 👉 Identify the user
      posthog.identify(userId, {
        email,
        company_title,
        customer_name,
        username,
        forename,
        surname,
      });
    }

    // 👉 Reset the user if they sign out
    if (!userId && posthog._isIdentified()) {
      posthog.reset();
    }
  }, [posthog, userId, email]);

  return null;
};

// Wrap this in Suspense to avoid the useSearchParams usage above
// from de-opting the whole app into client-side rendering
// See: https://nextjs.org/docs/messages/deopted-into-client-rendering
const SuspendedPostHogPageView = () => {
  return (
    <Suspense fallback={null}>
      <PostHogPageView />
    </Suspense>
  );
};

export default SuspendedPostHogPageView;
